'use es6';

import http from 'hub-http/clients/apiClient';
import { BLOG_API_BASE_URL } from '../Constants';
const fetch = () => http.get(`${BLOG_API_BASE_URL}/blog-listing-pages`, {
  query: {
    property: ['id', 'name', 'contentGroupId', 'currentState', 'screenshotPreviewUrl', 'securityState']
  }
});
export default {
  fetch
};